import { render, staticRenderFns } from "./RequiredResourcesList.vue?vue&type=template&id=4216985f&scoped=true"
import script from "./RequiredResourcesList.vue?vue&type=script&lang=js"
export * from "./RequiredResourcesList.vue?vue&type=script&lang=js"
import style0 from "./RequiredResourcesList.vue?vue&type=style&index=0&id=4216985f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4216985f",
  null
  
)

export default component.exports